import './CenterPlaqueFrame.css';
import backgroundImg from './background.png';

/** From Figma plaque_small background (154:32869 / 154:32870) — 226 775.6 628×375.8. */
export function CenterPlaqueFrame() {
  return (
    <img
      className="center-plaque-frame"
      src={backgroundImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
